import { HD, FULL_HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { Lightning } from '@lightningjs/sdk';
import { PRIMARY, makeThemeColor, DEFAULT_MODE } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { templates, sizes, imageOptions, LABEL_TEXT_TYPE } from './cover.constants';
import { WHITE, TRANSPARENT } from '../utils/colors';
import { getScreenSize } from '../utils/sizes';
import { BORDER_WIDTH } from '../utils/focus';

export const defaultContext = { screenSize: getScreenSize(), colorMode: DEFAULT_MODE };

export const IMAGE_PADDING_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const ALPHA_FOCUSED = 1;

export const ALPHA_UNFOCUSED = 0.6;

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const getImageSize = screenSize => imageOptions[templates.Cover][RENDERING_CONTEXT.GENERAL][screenSize].PRIMARY;

export const getImageRadius = screenSize => Math.round(getImageSize(screenSize).width / 2);

export const getBorderDiameter = screenSize => getImageSize(screenSize).width + BORDER_WIDTH[screenSize] * 2;

export const getBorderTexture = context => {
  const { screenSize } = context;
  const diameter = getBorderDiameter(screenSize);

  return Lightning.Tools.getRoundRect(
    diameter,
    diameter,
    getImageRadius(screenSize) + BORDER_WIDTH[screenSize],
    // NOTE: while border width should be equal to 3px, we adding an extra pixel to ensure there will be no gap between image and border
    BORDER_WIDTH[screenSize] + 1,
    WHITE,
    true,
    TRANSPARENT,
  );
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize = FULL_HD } = context;
  const { w } = sizes[templates.Cover][RENDERING_CONTEXT.GENERAL][screenSize];
  const imageSize = getImageSize(screenSize);
  const borderOffset = -BORDER_WIDTH[screenSize];

  return {
    alpha: ALPHA_UNFOCUSED,
    Border: {
      alpha: 0,
      radius: getImageRadius(screenSize),
      x: borderOffset,
      y: borderOffset,
    },
    Image: {
      w: imageSize.width,
      h: imageSize.height,
      shader: {
        radius: getImageRadius(screenSize),
      },
    },
    Label: {
      y: imageSize.height + IMAGE_PADDING_BOTTOM[screenSize],
      w,
      text: {
        ...getFont(FONT.KINSHASA_3, screenSize, LABEL_TEXT_TYPE),
        verticalAlign: 'middle',
        textAlign: 'center',
        wordBreak: true,
        advancedRenderer: true,
        maxLinesSuffix: '...',
        maxLines: 2,
        textOverflow: 'ellipsis',
      },
    },
  };
};

export const focusedStyle = {
  alpha: ALPHA_FOCUSED,
  Border: {
    smooth: {
      alpha: 1,
      scale: 1.05,
    },
  },
  Image: {
    smooth: {
      scale: 1.05,
    },
  },
};

export const unFocusedStyle = {
  alpha: ALPHA_UNFOCUSED,
  Border: {
    smooth: {
      alpha: 0,
      scale: 1,
    },
  },
  Image: {
    smooth: {
      scale: 1,
    },
  },
};
